// Pre-translated Cerebro welcome messages and starters
export const CEREBRO_TRANSLATIONS = {
  zh: {
    modeNames: {
      everyday: "日常天才",
      vision: "愿景模式",
      builder: "构建模式"
    },
    modeDescriptions: {
      everyday: "生活 + 工作 + 思考",
      vision: "创意 + 战略 + 未来",
      builder: "代码 + 系统"
    },
    suggestedQuestions: "建议的问题",
    welcomeMessages: {
      everyday: "你好！我是 Everyday Genius — 你的日常生活、工作和思考的超高效助手。\n\n我帮你快速解决问题，提供实用答案，并建议下一步行动。\n\n**今天我能帮你什么？**",
      vision: "欢迎来到 Vision Mode — 专注于创意、战略和长期规划的战略思考者。\n\n我用框架、识别杠杆点并提前标记风险来快速构建复杂主题。\n\n**你想探索什么战略挑战？**",
      builder: "欢迎来到 Builder Mode — 为实现速度优化的精英工程师和系统架构师。\n\n我首先输出可用代码，最小化解释，并默认生产就绪的解决方案。\n\n**你要构建什么？**"
    },
    starterQuestions: {
      everyday: [
        "帮我为下周计划高效的时间表",
        "给我写一封专业的电子邮件草稿",
        "解释量子计算的基础知识"
      ],
      vision: [
        "分析进入新市场的最佳策略",
        "为我的产品路线图识别关键杠杆点",
        "评估这个商业决策的上行和下行"
      ],
      builder: [
        "构建一个带身份验证的REST API",
        "创建一个React仪表板与图表",
        "编写Python脚本以自动化此工作流程"
      ]
    }
  }
};


export const getCerebroModeName = (modeId, language) => {
  if (language === 'zh' && CEREBRO_TRANSLATIONS.zh.modeNames[modeId]) {
    return CEREBRO_TRANSLATIONS.zh.modeNames[modeId];
  }
  const english = {
    everyday: "Everyday Genius",
    vision: "Vision Mode", 
    builder: "Builder Mode"
  };
  return english[modeId] || modeId;
};


export const getCerebroModeDescription = (modeId, language) => {
  if (language === 'zh' && CEREBRO_TRANSLATIONS.zh.modeDescriptions[modeId]) {
    return CEREBRO_TRANSLATIONS.zh.modeDescriptions[modeId];
  }
  // Fallback to English
  const english = {
    everyday: "Life + Work + Thinking",
    vision: "Ideas + Strategy + Future",
    builder: "Code + Systems"
  };
  return english[modeId] || "";
};

export const getCerebroThinkingLabel = (language) => {
  return language === 'zh' ? "思考中..." : "Thinking...";
};

export const getSuggestedQuestionsLabel = (language) => {
  if (language === 'zh') return "建议的问题";
  return "Suggested questions";
};


export const getCerebroWelcome = (modeId, language) => {
  if (language === 'zh' && CEREBRO_TRANSLATIONS.zh.welcomeMessages[modeId]) {
    return CEREBRO_TRANSLATIONS.zh.welcomeMessages[modeId];
  }
  const english = {
    everyday: "Hello! I'm Everyday Genius — your hyper-efficient assistant for daily life, work, and thinking.\n\nI help you solve problems quickly, provide practical answers, and suggest next steps.\n\n**What can I help you with today?**",
    vision: "Welcome to Vision Mode — strategic thinker focused on ideas, business, and long-term planning.\n\nI structure complex topics using frameworks, identify leverage points, and flag risks early.\n\n**What strategic challenge would you like to explore?**",
    builder: "Welcome to Builder Mode — elite engineer optimized for implementation speed.\n\nI output working code first, minimize explanations, and default to production-ready solutions.\n\n**What are you building?**"
  };
  return english[modeId] || english.everyday;
};

export const getCerebroStarters = (modeId, language) => {
  if (language === 'zh' && CEREBRO_TRANSLATIONS.zh.starterQuestions[modeId]) {
    return CEREBRO_TRANSLATIONS.zh.starterQuestions[modeId];
  }
  const english = {
    everyday: [
      "Help me plan an efficient schedule for next week",
      "Draft a professional email for me",
      "Explain quantum computing basics"
    ],
    vision: [
      "Analyze best strategy for entering a new market",
      "Identify key leverage points for my product roadmap",
      "Evaluate upside and downside of this business decision"
    ],
    builder: [
      "Build a REST API with authentication",
      "Create a React dashboard with charts",
      "Write a Python script to automate this workflow"
    ]
  };
  return english[modeId] || english.everyday;
};

